import { useFormContext } from '@calendly/form'

import { useEventTypeContext } from 'features/event_type_provider'

import { filterEnabledMemberships } from '../helpers'
import { AvailableMemberHours } from './available_hours'
import { BaseAvailability } from './base_availability'
import { findAvailabilityMembership } from './helpers'

export const PersonalAvailability = ({
  isLocked = false,
  isReadOnly = false
}) => {
  const { eventType, isSingleUseLink } = useEventTypeContext()
  const { isTeam } = eventType
  const { values: { event_type_memberships_attributes: eventTypeMembershipsAttributes, memberships } } = useFormContext()
  const membership = isTeam ? filterEnabledMemberships(memberships)[0] : memberships[0]
  const formMembership = findAvailabilityMembership(eventTypeMembershipsAttributes, membership)
  const formMembershipIndex = eventTypeMembershipsAttributes.indexOf(formMembership)

  return (
    <BaseAvailability isLocked={isLocked}>
      {formMembership && (
        <AvailableMemberHours
          key={formMembership.memberId || formMembership.userId}
          formPath={`event_type_memberships_attributes.${formMembershipIndex}`}
          isLocked={isLocked}
          isReadOnly={isReadOnly || isSingleUseLink}
        />
      )}
    </BaseAvailability>
  )
}
